import BannerImageEn from 'assets/ver2/referral/referral-banner-desktop-en.png';
import BannerImageVi from 'assets/ver2/referral/referral-banner-desktop-vi.png';
import ButtonCommon from 'components/common/ButtonCommon';
import { Title } from 'components/common/CollapsibleSideMenu/OuterPathContent';
import SizeBox from 'components/common/SizeBox';
import { getImgSrcByLang } from 'components/common/func';
import useReferral from 'features/referral/hooks/useReferral';
import useLang from 'hooks/useLang';
import styled from 'styled-components';
import ReferralContent from './components/ReferralContent';

const Referral = () => {
  const { t } = useLang();

  const {
    handleOnShare,
    formShareTitle,
    formShareDesc,
    formShareDesc2,
    labelOfShareButton,
    SendIcon,
    FormInputCopy,
    FormProgressBar,
    isReferee1st,
  } = useReferral();

  return (
    <ReferralStyled>
      <Title>{t('label_referral')} </Title>
      <SizeBox height={16} />
      <BannerImage src={getImgSrcByLang(BannerImageEn, BannerImageVi)} />
      <SizeBox height={10} />
      <SubTitle $isActive={isReferee1st}>{formShareTitle}</SubTitle>
      <SizeBox height={10} />
      <Desc>{formShareDesc}</Desc>
      <Desc>{formShareDesc2}</Desc>
      <SizeBox height={10} />
      <FormInputCopy isHideFormLabel />
      {FormProgressBar({ styles: { marginBottom: '16px' } })}
      <ButtonCommon
        value={labelOfShareButton}
        onClick={handleOnShare}
        color="var(--c-primary)"
        background="var(--bg-primary)"
        isFill={true}
        styles={{
          textTransform: 'unset',
          width: !SendIcon && '200px',
          height: '50px',
        }}
        buttonIconStyles={{
          textTransform: 'uppercase',
          paddingInline: '20px',
          minWidth: '200px',
          height: '50px',
          gap: 0,
        }}
        iconStyles={{
          width: '24px',
          borderRadius: 0,
        }}
        iconSrc={SendIcon}
      />
      <SizeBox height={30} />
      <ReferralContent />
    </ReferralStyled>
  );
};

const ReferralStyled = styled.div`
  display: inline-block;
  width: 667px;
  height: fit-content;
`;

const SubTitle = styled.p`
  font-family: var(--ff-tertiary);
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  text-transform: uppercase;
  color: ${(props) => (props.$isActive ? '#0000BE' : '#000')};
  margin: 0;

  display: flex;
  align-items: center;
`;

const Desc = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #0e1012;

  display: flex;
  align-items: center;
  margin-top: 0px;
  margin-bottom: 0px;
`;

const BannerImage = styled.img`
  width: 100%;
  min-height: 250px;
  height: 100%;
  border-radius: 12px;
  object-fit: contain;
`;

export default Referral;
